module.exports = __webpack_public_path__ + "img/316.9a26bde8.png";